import { createBreakpoint } from "react-use";
import { useCallback, useMemo } from "react";

const useNwBreakPoints = () => {
    // Usa useMemo per evitare ricreazioni inutili dell'hook di breakpoint
    const useBreakpointHook = useMemo(() => {
        try {
            // tablet parte da 721 e non da 720: le media query CSS usano "max-width: 720px",
            // quindi a 720px deve valere ancora il layout mobile anche lato JS
            return createBreakpoint({
                mobile: 0,
                tablet: 721,
                laptop: 1024,
                wide: 1280,
                xwide: 1600,
                xxwide: 1800
            });
        } catch (error) {
            // Fallback in caso di errori con ResizeObserver
            console.warn('ResizeObserver error in useNwBreakPoints, using fallback:', error);
            return () => 'laptop'; // Default fallback
        }
    }, []);

    // Usa useCallback per memoizzare la chiamata
    const getBreakpoint = useCallback(() => {
        try {
            return useBreakpointHook();
        } catch (error) {
            // Fallback sicuro
            console.warn('Error getting breakpoint, using default laptop:', error);
            return 'laptop';
        }
    }, [useBreakpointHook]);

    const breakpoint = getBreakpoint();

    // Usa useMemo per il mapping dei breakpoint
    return useMemo(() => {
        switch (breakpoint) {
            case "mobile":
                return 1;
            case "tablet":
                return 2;
            case "laptop":
                return 3;
            case "wide":
                return 4;
            case "xwide":
                return 5;
            case "xxwide":
                return 6;
            default:
                return 3;
        }
    }, [breakpoint]);
}

export default useNwBreakPoints;
